import { IAppMessage } from './types';

export const parseAppMessage = (data: string): IAppMessage | null =>
	typeof data === 'string'
		? data
			.split('&')
			.reduce((parsed, pair) => {
				const [key, value] = pair.split('=');

				return { ...parsed, [key]: value };
			}, {}) as IAppMessage
		: null;
